import { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function formatDate(d) {
  return d.toISOString().split("T")[0];
}

export function useScanData(market = "NSE", dateStr = null) {
  const [stocks, setStocks] = useState([]);
  const [regime, setRegime] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [scanDate, setScanDate] = useState(formatDate(new Date()));

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);

      const datesToTry = [];
      if (dateStr) {
        datesToTry.push(dateStr);
      } else {
        for (let i = 0; i < 7; i++) {
          const d = new Date();
          d.setDate(d.getDate() - i);
          datesToTry.push(formatDate(d));
        }
      }

      let foundDate = null;
      let allStocks = [];

      for (const date of datesToTry) {
        try {
          const testDoc = await getDoc(
            doc(db, "scanner", date, market, "chunk_1")
          );
          if (testDoc.exists()) {
            foundDate = date;
            let chunk = 1;
            while (chunk <= 10) {
              const chunkDoc = await getDoc(
                doc(db, "scanner", date, market, `chunk_${chunk}`)
              );
              if (!chunkDoc.exists()) break;
              const data = chunkDoc.data();
              if (data.stocks) allStocks.push(...data.stocks);
              if (data.updated_at?.toDate) {
                setLastUpdated(data.updated_at.toDate());
              }
              chunk++;
            }
            try {
              const regimeDoc = await getDoc(doc(db, "regime", date));
              if (regimeDoc.exists()) setRegime(regimeDoc.data());
            } catch (e) {}
            break;
          }
        } catch (e) {
          continue;
        }
      }

      if (foundDate) {
        setScanDate(foundDate);
        allStocks.sort((a, b) => (b.raw_score || 0) - (a.raw_score || 0));
        setStocks(allStocks);
      } else {
        setStocks([]);
      }
      setLoading(false);
    }
    fetchData();
  }, [market, dateStr]);

  return { stocks, regime, loading, error, lastUpdated, scanDate };
}